import React from 'react';
import { Link } from 'react-router-dom';
import './not_found.scss';

export default () => (
  <div className="center-block">
    <div className="error-title">404</div>
    <div className="error-subtitle">
      This is not a real page
      <div>
        <Link to="/">Click here to go back home.</Link>
      </div>
    </div>
  </div>
);
